import { v4 as uuidv4 } from 'uuid';
import { EVENTS } from './event-list';
import { selectors, store } from '../user/redux/store';

const EVENT_ATTRIBUTE = 'data-track-click';
const TRACKER_ENDPOINT = '/api/index.php?method=registerEvent';
const TRACK_ACTION = 'register-event';
const elementsToTrack = document.querySelectorAll(`[${EVENT_ATTRIBUTE}]`);

const getLoggedOutUUID = () => {
    if (!localStorage.sessionUUIDsn) {
        const sessionUUIDsn = uuidv4();
        localStorage.setItem('sessionUUIDsn', sessionUUIDsn);
        return sessionUUIDsn;
    }
    return localStorage.sessionUUIDsn;
};

const getDeviceType = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.match(/Android|BlackBerry|iPhone|iPod|Opera Mini|IEMobile|WPDesktop/i)) {
        return 'mobile';
    } else if (userAgent.match(/iPad/i) || userAgent.match(/Tablet/i)) {
        return 'tablet';
    } else {
        return 'desktop';
    }
};

const setupListeners = () => {

  elementsToTrack.forEach((element) => {
    element.addEventListener("click", () => {
      const eventValue = element.getAttribute(EVENT_ATTRIBUTE);
      trackClickEvent(eventValue);
    });
  });

  window.addEventListener("sg-tool-click", (e: Event) => {
    console.log('sg-tool-click', e)
    if ((e as CustomEvent).detail.value) {
      trackClickEvent((e as CustomEvent).detail.value);
    }
  });

  // other legacy events
  document.addEventListener("click_rewrite_cta", () =>
    trackClickEvent("rewrite-cta")
  );
  document.addEventListener("click_summarize_cta", () =>
    trackClickEvent("summarize-cta")
  );
};

export const trackClickEvent = (eventValue: string | null) => {
    if (!eventValue || !EVENTS[eventValue]) {
        return;
    }

    const { uuid: user_id } = selectors.auth.credentials(store.getState().auth);

    const data = {
        action: TRACK_ACTION,
        event_type_id: EVENTS[eventValue],
        uuid: getLoggedOutUUID(),
        user_uuid: user_id,
        url: window.location.pathname + window.location.search,
        device: getDeviceType(),
        referer: document.referrer,
    };

    const payload = JSON.stringify(data);
    navigator.sendBeacon(TRACKER_ENDPOINT, payload);
};

if (document.readyState !== 'loading') {
    setupListeners()
} else {
    document.addEventListener('DOMContentLoaded', setupListeners);
}
